/**
 * A sort function that accepts two elements and sorts them alphabetically.
 */
export function sortAlphabetically(a: string, b: string) {
    if (a < b) { return -1; }
    if (a > b) { return 1; }

    return 0;
}